const initialState = {
  loadingCreateReport: false,
  loadingUpdateReport: false,
  loadingReports: false,
  loadingReportById: false,
  loadingDownloadReport: false,
  loadingUploadImage: false,
  loadingReportActivityLogs: false,
  reportActivityLogs: [],
  savedReports: [],
  reportById: null,
  createdReport: null,
  updatedReport: null,
  uploadedImageUrl: null,
  errorsReport: {},
};

export default function ReportReducer(state = initialState, action) {
  switch (action.type) {
    case "CREATE_REPORT_PENDING":
      return { ...state, loadingCreateReport: true, errorsReport: {} };
    case "CREATE_REPORT_FULFILLED":
      return {
        ...state,
        loadingCreateReport: false,
        createdReport: action.payload,
      };
    case "CREATE_REPORT_REJECTED":
      return {
        ...state,
        loadingCreateReport: false,
        errorsReport: action.payload,
      };

    case "UPDATE_REPORT_PENDING":
      return { ...state, loadingUpdateReport: true, errorsReport: {} };
    case "UPDATE_REPORT_FULFILLED":
      return {
        ...state,
        loadingUpdateReport: false,
        updatedReport: action.payload,
      };
    case "UPDATE_REPORT_REJECTED":
      return {
        ...state,
        loadingUpdateReport: false,
        errorsReport: action.payload,
      };

    case "GET_REPORTS_PENDING":
      return { ...state, loadingReports: true, errorsReport: {} };
    case "GET_REPORTS_FULFILLED":
      return {
        ...state,
        loadingReports: false,
        savedReports: Array.isArray(action.payload)
          ? action.payload
          : action.payload?.data ?? [],
      };
    case "GET_REPORTS_REJECTED":
      return {
        ...state,
        loadingReports: false,
        errorsReport: action.payload,
      };

    case "GET_REPORT_BY_ID_PENDING":
      return { ...state, loadingReportById: true, reportById: null, errorsReport: {} };
    case "GET_REPORT_BY_ID_FULFILLED":
      return {
        ...state,
        loadingReportById: false,
        reportById: action.payload,
      };
    case "GET_REPORT_BY_ID_REJECTED":
      return {
        ...state,
        loadingReportById: false,
        errorsReport: action.payload,
      };

    case "DOWNLOAD_REPORT_PENDING":
      return { ...state, loadingDownloadReport: true, errorsReport: {} };
    case "DOWNLOAD_REPORT_FULFILLED":
      return { ...state, loadingDownloadReport: false };
    case "DOWNLOAD_REPORT_REJECTED":
      return {
        ...state,
        loadingDownloadReport: false,
        errorsReport: action.payload,
      };

    case "UPLOAD_IMAGE_PENDING":
      return { ...state, loadingUploadImage: true, uploadedImageUrl: null, errorsReport: {} };

    case "UPLOAD_IMAGE_FULFILLED":
      return { ...state, loadingUploadImage: false, uploadedImageUrl: action.payload };

    case "UPLOAD_IMAGE_REJECTED":
      return { ...state, loadingUploadImage: false, errorsReport: action.payload };

    case "GET_REPORT_ACTIVITY_LOGS_PENDING":
      return { ...state, loadingReportActivityLogs: true, reportActivityLogs: [], errorsReport: {} };
    case "GET_REPORT_ACTIVITY_LOGS_FULFILLED":
      return { ...state, loadingReportActivityLogs: false, reportActivityLogs: action.payload };
    case "GET_REPORT_ACTIVITY_LOGS_REJECTED":
      return { ...state, loadingReportActivityLogs: false, errorsReport: action.payload };

    default:
      return state;
  }
}

